var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('listarCliente',{attrs:{"titulo":'Detalles del pedido'}}),_c('verPedido')],1)}
var staticRenderFns = []

export { render, staticRenderFns }